module.exports = __webpack_public_path__ + "img/17m.06b2a0ca.jpg";